<style src="./style.scss">
</style>

<script>
  import { afterUpdate } from "svelte";

  import ArrowLeftIcon from "@assets/icons/arrow-left.svg";
  import Badge from "@components/badge";
  import Button from "@components/button";
  import Footer from "@components/footer";
  import Header from "@components/header";
  import CheckIcon from "@assets/icons/check.svg";
  import Icon from "svelte-icon";
  import Modal from "@components/modal";
  import Spinner from "@components/spinner";
  import TextInput from "@components/textInput";
  import Toast from "@components/toast";
  import { query, mutation } from "svelte-apollo";
  import { navigate, useParams } from "svelte-navigator";

  import SubscriptionModal from "./modals/subscrption.svelte";

  import { getScreenSize, PRIVACITY_LINK } from "@utils";

  import { GIFT_CARD_QUERY } from "./giftCard.query.ts";
  import { VERIFY_EMAIL_QUERY } from "./verifyEmail.query.ts";
  import { REDEEM_CODE_MUTATION } from "./reddemCode.mutation.ts";
  import { isFullNameValid } from "@utils/account";

  const params = useParams();

  const screenWidth = getScreenSize().width;

  let message = {
    error: "",
    visible: false,
    text: "",
    toastType: "",
  };

  let isLoading = true;
  let hasEmail = false;
  let validEmail = true;
  let disabledEmailField = true;
  let email = "";
  let planDetailsModal = false;
  let giftCard = {};
  let subscrptionModal = false;
  let subscribedStatus = "";
  let isFetchingEmail = false;
  let fullName = "";
  let hasValidName = true;
  let isSubmitting = false;

  const currentDate = new Date().toLocaleDateString("pt-br");

  let isValidEmail = (value) => {
    const pattern = /\S+@\S+\.\S+/;
    return pattern.test(value);
  };

  const redeemCode = mutation(REDEEM_CODE_MUTATION);
  const verifyEmailQuery = query(VERIFY_EMAIL_QUERY, {
    variables: { input: { email } },
  });
  const giftCardQuery = query(GIFT_CARD_QUERY, {
    variables: {
      id: $params.id,
    },
  });

  afterUpdate(() => {
    if ($giftCardQuery.data) {
      if ($giftCardQuery.data.giftCard) {
        isLoading = false;

        if (!giftCard.id) {
          giftCard = $giftCardQuery.data.giftCard;

          if (giftCard.redeemAt) {
            subscrptionModal = true;
            isLoading = false;
            return true;
          }

          verifyExpirationDate(giftCard.expiresAt);
          return;
        }
      }

      if (!$giftCardQuery.data.giftCard) {
        isLoading = false;

        showMessage("Cupom não encontrado.", "alert");
      }
    }
  });

  function verifyExpirationDate(expiresAt) {
    const today = new Date().getTime();

    if (expiresAt && today > expiresAt) {
      showMessage(
        "Este cupom está expirado, não é possível resgatar para uma assinatura no CNA Go.",
        "alert"
      );

      return;
    }

    disabledEmailField = false;
  }

  function parseProductDescription(description) {
    if (description) {
      return description.split(/\n/);
    }

    return "";
  }

  function showMessage(text, toastType) {
    message = {
      toastType,
      text,
      visible: true,
    };
  }

  function clearMessage() {
    message = { visible: false, text: "", toastType: "alert" };
  }

  function getBadgeName() {
    if (giftCard.id) {
      return `${giftCard.price.product.name} - ${giftCard.price.name}`;
    }

    return "";
  }

  function getBadgeBackground() {
    if (giftCard.id) {
      return giftCard.price.product.color;
    }

    return "";
  }

  function getExpirationDate(recurringInterval) {
    const today = new Date();

    switch (recurringInterval) {
      case "YEAR":
        return new Date(
          today.setFullYear(today.getFullYear() + 1)
        ).toLocaleDateString("pt-br");
        break;
      case "QUARTERLY":
        return new Date(
          today.setMonth(today.getMonth() + 3)
        ).toLocaleDateString("pt-br");
        break;
      case "SEMIANNUAL":
        return new Date(
          today.setMonth(today.getMonth() + 6)
        ).toLocaleDateString("pt-br");
        break;
      default:
        return new Date(
          today.setMonth(today.getMonth() + 1)
        ).toLocaleDateString("pt-br");
        break;
    }
  }

  function getRecurringIntervalPeriodName(interval) {
    switch (interval) {
      case "YEAR":
        return "12 meses";
        break;
      case "QUARTERLY":
        return "3 meses";
        break;
      case "SEMIANNUAL":
        return "6 meses";
        break;
      default:
        return "1 mês";
        break;
    }
  }

  function hasLinks() {
    return giftCard?.deal?.termsOfUseUrl ||
      giftCard?.price?.product.options.length > 0
      ? true
      : false;
  }

  async function submit() {

    hasValidName = isFullNameValid(fullName);
    
    if (!hasValidName && subscribedStatus === "new-account") {
      showMessage("Digite seu nome completo", "alert");
      window.scrollTo(0, 0);
      return;
    }
    
    isSubmitting = true;

    const { data, errors } = await redeemCode({
      variables: {
        input: { code: $params.id, email, name: fullName },
      },
      errorPolicy: "all",
    });

    isSubmitting = false;
    
    if (data) {
      const { status } = data?.redeemCode;

      navigate(
        subscribedStatus === "completed"
          ? "/checkout-success"
          : `/create-account?email=${email}`
      );

      return;
    }

    showMessage(
      "Este cupom está expirado, não é possível resgatar para uma assinatura no CNA Go.",
      "alert"
    );
  }

  async function fetchEmail() {
    isLoading = true;

    if (email === "") {
      return false;
    }

    if (!isValidEmail(email)) {
      hasEmail = true;
      validEmail = false;
      isLoading = false;

      return;
    }

    if (verifyEmailQuery) {
      isFetchingEmail = true;
      const { data } = await verifyEmailQuery.refetch({ input: { email } });

      if (data.verifyEmail?.status) {
        subscribedStatus = data.verifyEmail?.status || "";
      }

      if (data.verifyEmail?.status === "invalid-email") {
        validEmail = false;
        hasEmail = true;

        showMessage("E-mail inválido, tente novamente.", "alert");

        isFetchingEmail = false;
        isLoading = false;

        return;
      }

      isFetchingEmail = false;
      validEmail = true;
      hasEmail = true;
      isLoading = false;
    }
  }

  function getTermsLink() {
    if (giftCard?.deal?.termsOfUseUrl) {
      return giftCard?.deal.termsOfUseUrl;
    }

    if (giftCard?.price?.product?.options) {
      const option = options.find(({ name }) => name === "termsOfUseURL");

      if (!option) {
        return "";
      }

      return option?.value;
    }

    return "";
  }
</script>

<Modal
  isOpen="{planDetailsModal}"
  title="Detalhes do plano"
  onClose="{() => (planDetailsModal = false)}">
  <div>
    <div class="plan-details-modal-badge">
      <Badge title="{getBadgeName()}" background="{getBadgeBackground()}" />
    </div>
    <p class="redeem__message">
      {#each parseProductDescription(giftCard?.price?.product?.description) as description, index}
        {#if description}
          <Icon data="{CheckIcon}" size="10px" stroke="transparent" />
          {description}<br />
        {/if}
      {/each}
    </p>
  </div>
</Modal>

{#if subscrptionModal}
  <SubscriptionModal
    isOpen="{subscrptionModal}"
    price="{giftCard?.price}"
    onClose="{() => null}" />
{/if}

{#if !subscrptionModal}
  <Header steps="{[1, 2, 3]}" activeStep="{0}" />

  <div class="redeem">
    {#if isLoading || isSubmitting}
      <Spinner />
    {:else}
      {#if message?.visible}
        <div class="toast-container">
          <div>
            <Toast
              message="{message?.text}"
              toastType="{message?.toastType}"
              visible="{message?.visible}"
              onClose="{clearMessage}" />
          </div>
        </div>
      {/if}

      <div class="redeem__container">
        <div class="redeem__content">
          <h1>Ative sua assinatura</h1>

          {#if giftCard?.deal?.imageUrl}
            <img src="{giftCard?.deal?.imageUrl}" alt="" />
          {/if}

          {#if giftCard?.deal?.description}
            <p>
              {giftCard?.deal?.description}
            </p>
          {/if}

          <div class="redeem__form">
            <TextInput
              label="E-mail"
              placeholder="Digite seu e-mail"
              disabled="{disabledEmailField}"
              isLoading="{isFetchingEmail}"
              success="{hasEmail && validEmail}"
              error="{!validEmail && hasEmail}"
              onBlur="{fetchEmail}"
              bind:value="{email}"
              type="email" />
          </div>
          
          {#if subscribedStatus === "new-account"}
            <div class="redeem__form">
              <TextInput
              label="Precisamos do seu nome completo também."
              placeholder="Digite seu nome completo"
              error="{!hasValidName}"
              bind:value="{fullName}"
              type="text" />
            </div>
          {/if}

          <div class="desktop-only">
            <Button
              title="Ativar assinatura"
              type="success"
              onClick="{submit}"
              disabled="{!isValidEmail(email)}" />

            {#if hasLinks()}
              <div class="redeem__terms">
                Declaro que li e aceitei a <a
                  href="{PRIVACITY_LINK}"
                  target="_blank">Política de Privacidade</a>
                e os
                <a href="{getTermsLink()}" target="_blank">Termos.</a>
              </div>
            {:else}
              <div class="redeem__terms">
                Declaro que li e aceitei a <a
                  href="{PRIVACITY_LINK}"
                  target="_blank">Política de Privacidade</a>
              </div>
            {/if}
          </div>
        </div>

        <div class="redeem__divisor mobile-only"></div>

        <div class="redeem__content">
          <h1>Plano que será ativado</h1>

          <div class="redeem__selected-plan">
            <Badge
              title="{getBadgeName()}"
              background="{getBadgeBackground()}" />
            <div
              class="plan-details mobile-only"
              on:click="{() => (planDetailsModal = true)}">
              Detalhes do plano
              <Icon
                data="{ArrowLeftIcon}"
                size="12px"
                stroke="transparent"
                fill="#FFFFFF" />
            </div>
          </div>

          <div class="redeem__duration">
            <div>
              <div>
                <div>Duração</div>
                <div>
                  {getRecurringIntervalPeriodName(
                    giftCard?.price?.recurringInterval
                  )}
                </div>
              </div>
            </div>
            <div>
              Período de assinatura: {currentDate} - {getExpirationDate(
                giftCard?.price?.recurringInterval
              )}
            </div>
          </div>

          <div class="desktop-only">
            <h1>Detalhes do plano</h1>

            <div class="redeem__divisor"></div>
            <p class="redeem__description">
              {#each parseProductDescription(giftCard?.price?.product?.description) as description, index}
                {#if description}
                  • {description}<br />
                {/if}
              {/each}
            </p>
          </div>

          <div class="mobile-only send-button">
            <Button
              title="Ativar assinatura"
              type="success"
              onClick="{submit}"
              disabled="{!isValidEmail(email)}" />

            {#if hasLinks()}
              <div class="redeem__terms">
                Declaro que li e aceitei a <a
                  href="{PRIVACITY_LINK}"
                  target="_blank">Política de Privacidade</a>
                e os
                <a href="{getTermsLink()}" target="_blank">Termos.</a>
              </div>
            {:else}
              <div class="redeem__terms">
                Declaro que li e aceitei a <a
                  href="{PRIVACITY_LINK}"
                  target="_blank">Política de Privacidade</a>
              </div>
            {/if}
          </div>
        </div>
      </div>
    {/if}
    <div class="desktop-only">
      <Footer />
    </div>
  </div>
{/if}
